export default __webpack_public_path__ + "static/media/academics.32f6cab0.svg";